export const environment = {
	production: true,
	serviceWorker: true,
	appVersion: '1.1.7',
	settings: {
		//backend: 'http://181.13.123.30:5015/',
		backend: 'https://api-telemetria.bytechnology.com.ar/',
		//backend: 'https://api-telemetria.bytechnology.com.ar/',
		// backend: 'https://api-telemetria.bytechnology.com.ar/'
		// backend: 'https://api-telemetria.bytechnology.com.ar/'
	},
};
